import styled from '@emotion/styled';
import { Colors } from 'styles/variables/colors';
import { ReactComponent as CrossSimpleIcon } from 'assets/icons/cross-simple.svg';

export const Container = styled.div<{ mobile: boolean }>`
    width: ${({ mobile }) => (mobile ? '280px' : '450px')};
    display: flex;
    flex-direction: column;
    gap: 1rem;
    justify-content: center;
    border-radius: 4px;
    padding: 1rem;
    margin-top: 0.5rem;
`;

export const Row = styled.div`
    display: flex;
    align-items: center;
`;

export const Explanation = styled.span`
    cursor: pointer;
`;

export const FullExplanation = styled.div`
    max-height: 320px;
    overflow-y: auto;
`;

export const Title = styled.div`
    font-family: 'Assistant';
    font-style: normal;
    font-weight: 600;
    font-size: 15px;
    line-height: 20px;
    height: 48px;
    background: ${Colors.tableHeader};
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    padding: 18px;
`;

export const CloseIcon = styled(CrossSimpleIcon)`
    cursor: pointer;
    path {
        fill: ${Colors.gray};
    }
    width: 9px;
    height: 9px;
`;

export const TextForActionsDropdown = styled.span`
    font-family: 'Montserrat', sans-serif;
    font-weight: 500;
    font-size: 14px;
    color: ${Colors.darkGray};
`;
